<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col>
        <v-card>
          <v-card-title>
            <v-icon large>mdi-account-multiple</v-icon>
            <h3>{{ $tt('customConnectionTitle') }}</h3>
          </v-card-title>
          <v-card-text>
            <v-tabs v-model="tab" show-arrows color="primary">
              <v-tab class="text-none">{{ followingTitle }}</v-tab>
              <v-tab class="text-none">{{ followerTitle }}</v-tab>
            </v-tabs>
            <v-card flat>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card-text v-if="followings.length == 0">{{ $tt('customHaveNoFollowings') }}</v-card-text>
                  <v-row>
                    <v-col cols="6" md="3" v-for="acc in followings" :key="acc.uuid">
                      <v-card height="200" max-width="300">
                        <v-container fill-height>
                          <v-layout column justify-center align-center>
                            <user-icon-component size="70" :showNickname="false" :iconUrl="acc.iconUrl" />
                            <p>{{ acc.nickname }}</p>
                            <v-btn
                              color="warning"
                              @click="
                                dialog = true
                                account = acc
                              "
                              >{{ $tt('customUnfollow') }}</v-btn
                            >
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-card-text v-if="followers.length == 0">{{ $tt('customHaveNoFollowers') }}</v-card-text>
                  <v-row>
                    <v-col cols="6" md="3" v-for="acc in followers" :key="acc.uuid">
                      <v-card height="200" max-width="300">
                        <v-container fill-height>
                          <v-layout column justify-center align-center>
                            <user-icon-component size="70" :showNickname="false" :iconUrl="acc.iconUrl" />
                            <p>{{ acc.nickname }}</p>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="300">
      <v-card>
        <v-card-title>{{ $tt('customConfirmReally') }}</v-card-title>
        <v-card-actions>
          <v-btn color="primary" @click="dialog = false">{{ $tt('customCancel') }}</v-btn>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            outlined
            @click.stop.prevent="
              dialog = false
              unsubscribeAccount(account)
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import UserIconComponent from '@/components/user/UserIconComponent'

export default {
  name: 'user-connections',
  components: { UserIconComponent },
  mounted: function() {
    this.fetchSubscriptionInfo()
    this.$store.dispatch('refreshAccessToken')
  },

  data: () => ({
    tab: null,
    account: null,
    dialog: false,
  }),

  computed: {
    followings() {
      return this.$store.getters.subscribingAccounts
    },
    followers() {
      return this.$store.getters.subscriberAccounts
    },
    followingTitle() {
      return this.$tt('customFollowing') + ' (' + this.followings.length + ')'
    },
    followerTitle() {
      return this.$tt('customFollower') + ' (' + this.followers.length + ')'
    },
  },

  methods: {
    fetchSubscriptionInfo() {
      this.$store.dispatch('fetchSubscriptionInfo')
    },
    unsubscribeAccount(account) {
      this.$store.dispatch('unsubscribeAccount', account.uuid)
    },
  },
}
</script>
